import isEmail from "validator/lib/isEmail";
import isURL from "validator/lib/isURL";

export default {
  data: () => ({
    requiredKeys: [
      "organisationName",
      "addressLine1",
      "postalCode",
      "businessStructure",
      "businessDescription",
      "naicsCode",
      "noOfEmployees",
      "fullYearRevenue",
    ],
  }),

  computed: {
    checkEmail() {
      return (value) => {
        return isEmail(value, {
          allow_utf8_local_part: false,
        });
      };
    },
  },

  methods: {
    isFormComplete(form) {
      const errors = [];
      for (let key in form) {
        if (this.requiredKeys.includes(key)) {
          if (form[key] === "") {
            errors.push(`${key.toLowerCase()} is required`);
          }
        }
      }
      return {
        valid: !errors.length,
        errors,
      };
    },

    validURL(str) {
      return isURL(str);
    },

    onBlur(type, formName) {
      this.elevate = false;
      if (formName === "signupForm") this["signupForm"][type] = this.signupForm[type]?.trim();

      if (formName === "paymentForm") {
        switch (type) {
          case "number":
          case "expireDate":
          case "cvc":
            this.paymentForm.card[type] = this.paymentForm.card[type]?.trim();
            return;
          case "name":
            this.paymentForm.billing_details[type] = this.paymentForm.billing_details[type]?.trim();
            return;
          case "line1":
          case "country":
          case "state":
          case "city":
          case "postal_code":
            this.paymentForm.billing_details.address[type] =
              this.paymentForm.billing_details.address[type]?.trim();
            return;
          case "promo_code":
            this.paymentForm[type] = this.paymentForm[type]?.trim();
            return;
        }
      }
    },

    trim(str) {
      return str?.trim();
    },

    hasSpecialChars(str) {
      const restrict = '!@#$%^*()_={}[]|/<>:;"~`?'.split("");
      return !restrict.some((v) => str.includes(v));
    },

    isValidUSAPhoneNumber(phoneNumber) {
      // Define a regular expression to match the pattern
      const regex = /^\([2-9]\d{2}\) \d{3}-\d{4}$/;
      return regex.test(phoneNumber);
    },

    isNotFreeTypeEmailAddress(email) {
      const regex =
        /^[a-zA-Z0-9._%+-]+@(?!gmail.com)(?!yahoo.com)(?!hotmail.com)(?!yahoo.co.in)(?!aol.com)(?!live.com)(?!outlook.com)(?!yopmail.com)[a-zA-Z0-9_-]+.[a-zA-Z0-9-.]{2,61}$/;
      return regex.test(email);
    },
  },
};
